import React from 'react';
import { View, StyleSheet } from 'react-native';
import { typeColors, TypeVariant } from './types';

export interface TypeIconProps {
  /**
   * The type variant that determines the color
   */
  variant: TypeVariant;

  /**
   * Size of the icon in pixels (12 or 16)
   */
  size?: 12 | 16;

  /**
   * Test ID for testing
   */
  testID?: string;
}

export const TypeIcon: React.FC<TypeIconProps> = ({
  variant,
  size = 16,
  testID,
}) => {
  const backgroundColor = typeColors[variant];

  return (
    <View
      style={[
        styles.container,
        {
          width: size,
          height: size,
          backgroundColor,
          borderRadius: size / 4, // 25% of size for rounded corners
        },
      ]}
      testID={testID}
      accessibilityRole="image"
      accessibilityLabel={`${variant} type indicator`}
    />
  );
};

TypeIcon.displayName = 'TypeIcon';

const styles = StyleSheet.create({
  container: {
    // Dimensions and color are set dynamically
  },
});
